<template>
    <v-content style="padding-top: 6px; padding-bottom: 6px;">
      <v-container fluid>
        <v-layout justify-space-around row wrap>
          <v-flex xs12 md5 lg3>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex
                        v-for="n in 9"
                        :key="n"
                        xs4>
                        <v-hover>
                        <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                        class="mx-auto"
                        tile>
                          <v-img
                            :src="`https://leif.ileksand.se/instaimages/0${Math.floor(Math.random() * 93) + 1}.png`"
                            height="120px"
                          ></v-img>
                        </v-card>
                      </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
          <v-flex xs12 md6 lg4>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <!--v-img :src="require('@/assets/snazzyImage.png')" height="282px" style="border: 22px solid white;">
              </v-img-->
              <iframe v-if="hover" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30033.50422086576!2d14.931304722173916!3d60.74133566608993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNjDCsDQ0JzExLjkiTiAxNMKwNTgnNDkuNiJF!5e0!3m2!1sen!2sse!4v1550129986284" width="100%" height="277" frameborder="0" style="border:0" allowfullscreen></iframe>
              <iframe v-else src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983447.300251397!2d12.31436411205035!3d59.00714306364536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNjDCsDQ0JzExLjkiTiAxNMKwNTgnNDkuNiJF!5e0!3m2!1sen!2sse!4v1550130111816" width="100%" height="277" frameborder="0" style="border:0" allowfullscreen></iframe>
              <v-card-text>Kontakta oss: </v-card-text>
              <v-card-text>Förening/Projekt - Mattias Gyllenhak Liss 076 804 33 40<br/>Utställning/Film: Martin Sandström Rimsbo 070 797 82 38</v-card-text>
            </v-card>
          </v-hover>
          </v-flex>
          <v-flex xs12 md6 lg3 class="hideonsmallerscreen" >
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex
                        v-for="n in 9"
                        :key="n"
                        xs4>
                        <v-hover>
                        <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                        class="mx-auto"
                        tile>
                          <v-img
                            :src="`https://leif.ileksand.se/instaimages/0${Math.floor(Math.random() * 93) + 1}.png`"
                            height="120px"
                          ></v-img>
                        </v-card>
                      </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  export default {
    data: () => ({
      drawer: null
    }),
    props: {
      source: String
    },
    mounted () {
    }
  }
</script>
<style>
@media (max-width: 1264px) {
  .hideonsmallerscreen {
    display: none;
  }
}
</style>
